import { render, staticRenderFns } from "./FindingInfoByOrgan.vue?vue&type=template&id=5b52e09a&scoped=true&"
import script from "./FindingInfoByOrgan.vue?vue&type=script&lang=js&"
export * from "./FindingInfoByOrgan.vue?vue&type=script&lang=js&"
import style0 from "./FindingInfoByOrgan.vue?vue&type=style&index=0&id=5b52e09a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52e09a",
  null
  
)

export default component.exports